import React from 'react';
import { Empty } from 'antd';
import selectionStore from '../../Store/selectionStore';
import ZonePanel from './ZonePanel';
import ScreenPanel from './ScreenPanel';
import ButtonPanel from './ButtonPanel';

function Panel() {
  const mode = selectionStore.useState((s) => s.mode);

  if (mode === 'zone') return <ZonePanel />;
  if (mode === 'screen') return <ScreenPanel />;
  if (mode === 'button') return <ButtonPanel />;

  return <Empty description="Выберите экран или кнопку на схеме" />;
}

export default Panel;
